const users = state => state.users

export default {
  users,
}



// WEBPACK FOOTER //
// ./src/devicehq/store/modules/users/getters.js